import {
  STORE_BROWSE_ADS_LOCALY,
  STORE_WHOISONLINE_RECENT_ADS_LOCALY,
  STORE_WHOISONLINE_WEEK_ADS_LOCALY
} from '../../constants/actions';

// store ads for browse scene, so we don't have to load that many ads
const initialState = {
  browseAds: [],
  whoIsOnlineRecentAds: [],
  whoIsOnlineWeekAds: []
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case STORE_BROWSE_ADS_LOCALY:
      return {
        ...state,
        browseAds: action.data
      };
    case STORE_WHOISONLINE_RECENT_ADS_LOCALY:
      return {
        ...state,
        whoIsOnlineRecentAds: action.data
      };
    case STORE_WHOISONLINE_WEEK_ADS_LOCALY:
      return {
        ...state,
        whoIsOnlineWeekAds: action.data
      };
    default:
      return state;
  }
}
